/**
 * KJAR Lens Selection Wizard - Modal Panel
 * Opens as a slide-in panel when Add to Cart is clicked
 *
 * SUNGLASSES:
 * Directly add selected variant to cart.
 *
 * EYEGLASSES / OTHER PRODUCTS:
 * Open lens selection wizard.
 */
(function () {
  'use strict';

  let state = {
    currentStep: 1,
    powerType: null,
    selectedLens: null,
    prescriptionMode: 'manual',
    uploadedFile: null,
    productId: null,
    variantId: null,
    framePrice: 0,
    isSunglasses: false,
  };

  function init() {
    // Build modal if lens data exists on page
    const lensData = document.querySelector(
      '.kjar-lens-wizard-data'
    );

    if (!lensData) return;

    state.productId =
      lensData.dataset.productId;

    state.variantId =
      lensData.dataset.variantId;

    state.framePrice =
      parseFloat(
        lensData.dataset.framePrice || '0'
      );

    /*
     * Detect Shopify product type.
     */
    var productType = '';

    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product
    ) {
      productType =
        window.ShopifyAnalytics.meta.product.type ||
        '';
    }

    if (
      !productType &&
      window.meta &&
      window.meta.product
    ) {
      productType =
        window.meta.product.type || '';
    }

    state.isSunglasses =
      productType
        .trim()
        .toLowerCase() === 'sunglasses';

    buildModal(lensData);
    bindAddToCartIntercept();
  }

  /**
   * Build modal DOM from hidden data div
   */
  function buildModal(dataEl) {
    const overlay =
      document.createElement('div');

    overlay.className =
      'kjar-wizard-overlay';

    overlay.id =
      'kjar-wizard-overlay';

    const panel =
      document.createElement('div');

    panel.className =
      'kjar-wizard-panel';

    panel.id =
      'kjar-wizard-panel';

    panel.innerHTML = `
      <div class="kjar-wizard-panel__header">

        <h2 class="kjar-wizard-panel__title">
          Customize Your Lenses
        </h2>

        <button
          class="kjar-wizard-panel__close"
          id="kjar-wizard-close"
        >
          &times;
        </button>

      </div>

      <div class="kjar-wizard-panel__body">

        <div class="kjar-wizard__progress">

          <div class="kjar-wizard__step-indicator">

            <span
              class="kjar-wizard__step-dot kjar-wizard__step-dot--active"
            >
              1
            </span>

            <span
              class="kjar-wizard__step-label kjar-wizard__step-label--active"
            >
              Power
            </span>

          </div>

          <span class="kjar-wizard__step-line"></span>

          <div class="kjar-wizard__step-indicator">

            <span class="kjar-wizard__step-dot">
              2
            </span>

            <span class="kjar-wizard__step-label">
              Lens
            </span>

          </div>

          <span class="kjar-wizard__step-line"></span>

          <div class="kjar-wizard__step-indicator">

            <span class="kjar-wizard__step-dot">
              3
            </span>

            <span class="kjar-wizard__step-label">
              Rx
            </span>

          </div>

          <span class="kjar-wizard__step-line"></span>

          <div class="kjar-wizard__step-indicator">

            <span class="kjar-wizard__step-dot">
              4
            </span>

            <span class="kjar-wizard__step-label">
              Done
            </span>

          </div>

        </div>

        <div
          class="kjar-wizard__error"
          id="kjar-wizard-error"
        ></div>

        <!-- =====================================================
             STEP 1
             ===================================================== -->

        <div
          class="kjar-wizard__step kjar-wizard__step--active"
        >

          <h3 class="kjar-wizard__step-title">
            Select Power Type
          </h3>

          <p class="kjar-wizard__step-subtitle">
            Choose the lens power that matches your needs
          </p>

          <div class="kjar-wizard__options">

            ${
              state.isSunglasses
                ? `

                  <!-- =========================================
                       SUNGLASSES
                       ========================================= -->

                  <div
                    class="kjar-wizard__option"
                    data-power-type="zero_power"
                  >

                    <span
                      class="kjar-wizard__option-radio"
                    ></span>

                    <span
                      class="kjar-wizard__option-icon"
                    >
                      ⚪
                    </span>

                    <span
                      class="kjar-wizard__option-name"
                    >
                      Zero Power
                    </span>

                    <span
                      class="kjar-wizard__option-desc"
                    >
                      Clear lenses, no correction
                    </span>

                  </div>

                  <div
                    class="kjar-wizard__option"
                    data-power-type="progressive"
                  >

                    <span
                      class="kjar-wizard__option-radio"
                    ></span>

                    <span
                      class="kjar-wizard__option-icon"
                    >
                      🔄
                    </span>

                    <span
                      class="kjar-wizard__option-name"
                    >
                      Progressive
                    </span>

                    <span
                      class="kjar-wizard__option-desc"
                    >
                      Seamless multi-distance, no line
                    </span>

                  </div>

                `
                : `

                  <!-- =========================================
                       EYEGLASSES / OTHER PRODUCTS
                       ALL FIVE OPTIONS
                       ========================================= -->

                  <div
                    class="kjar-wizard__option"
                    data-power-type="frame_only"
                  >

                    <span
                      class="kjar-wizard__option-radio"
                    ></span>

                    <span
                      class="kjar-wizard__option-icon"
                    >
                      👓
                    </span>

                    <span
                      class="kjar-wizard__option-name"
                    >
                      Frame Only
                    </span>

                    <span
                      class="kjar-wizard__option-desc"
                    >
                      No prescription needed
                    </span>

                  </div>

                  <div
                    class="kjar-wizard__option"
                    data-power-type="single_vision"
                  >

                    <span
                      class="kjar-wizard__option-radio"
                    ></span>

                    <span
                      class="kjar-wizard__option-icon"
                    >
                      🔍
                    </span>

                    <span
                      class="kjar-wizard__option-name"
                    >
                      Single Vision
                    </span>

                    <span
                      class="kjar-wizard__option-desc"
                    >
                      Near or distance
                    </span>

                  </div>

                  <div
                    class="kjar-wizard__option"
                    data-power-type="zero_power"
                  >

                    <span
                      class="kjar-wizard__option-radio"
                    ></span>

                    <span
                      class="kjar-wizard__option-icon"
                    >
                      ⚪
                    </span>

                    <span
                      class="kjar-wizard__option-name"
                    >
                      Zero Power
                    </span>

                    <span
                      class="kjar-wizard__option-desc"
                    >
                      Clear lenses, no correction
                    </span>

                  </div>

                  <div
                    class="kjar-wizard__option"
                    data-power-type="bifocal"
                  >

                    <span
                      class="kjar-wizard__option-radio"
                    ></span>

                    <span
                      class="kjar-wizard__option-icon"
                    >
                      📖
                    </span>

                    <span
                      class="kjar-wizard__option-name"
                    >
                      Bifocal
                    </span>

                    <span
                      class="kjar-wizard__option-desc"
                    >
                      Near + distance, visible line
                    </span>

                  </div>

                  <div
                    class="kjar-wizard__option"
                    data-power-type="progressive"
                  >

                    <span
                      class="kjar-wizard__option-radio"
                    ></span>

                    <span
                      class="kjar-wizard__option-icon"
                    >
                      🔄
                    </span>

                    <span
                      class="kjar-wizard__option-name"
                    >
                      Progressive
                    </span>

                    <span
                      class="kjar-wizard__option-desc"
                    >
                      Seamless multi-distance, no line
                    </span>

                  </div>

                `
            }

          </div>

        </div>

        <!-- =====================================================
             STEP 2
             ===================================================== -->

        <div class="kjar-wizard__step">

          <h3 class="kjar-wizard__step-title">
            Select Lens Type
          </h3>

          <p class="kjar-wizard__step-subtitle">
            Choose your preferred lens for optimal clarity
          </p>

          <div class="kjar-lens-list">

            ${
              dataEl.querySelector(
                '.kjar-wizard-data__lenses'
              )?.innerHTML ||
              '<p style="color:#9E9E9E;font-size:0.8rem;">No lens types configured. Please set up lens_type metaobjects in Shopify admin.</p>'
            }

          </div>

        </div>

        <!-- =====================================================
             STEP 3
             ===================================================== -->

        <div class="kjar-wizard__step">

          <h3 class="kjar-wizard__step-title">
            Add Prescription
          </h3>

          <p class="kjar-wizard__step-subtitle">
            Enter your power details or upload your prescription
          </p>

          <div class="kjar-prescription__tabs">

            <button
              class="kjar-prescription__tab kjar-prescription__tab--active"
              data-prescription-mode="manual"
            >
              Enter Power Manually
            </button>

            <button
              class="kjar-prescription__tab"
              data-prescription-mode="upload"
            >
              Upload Prescription
            </button>

          </div>

          <div
            class="kjar-prescription__tab-content kjar-prescription__tab-content--active"
            data-prescription-mode="manual"
          >

            <div
              id="kjar-progressive-alert"
              class="kjar-alert kjar-alert--progressive"
              style="display:none;"
            >

              <span class="kjar-alert__icon">
                ⚠️
              </span>

              <span class="kjar-alert__text">
                PD (Pupillary Distance) is essential for progressive lenses.
                Please ensure it's measured accurately.
              </span>

            </div>

            <div class="kjar-prescription__eyes">

              <!-- RIGHT EYE -->

              <div class="kjar-prescription__eye">

                <span class="kjar-prescription__eye-label">
                  Right Eye (OD)
                </span>

                <div class="kjar-form-group">

                  <label
                    class="kjar-form-label"
                    for="kjar-right-sph"
                  >
                    SPH (Sphere)
                  </label>

                  <select
                    id="kjar-right-sph"
                    class="kjar-form-input kjar-form-select"
                  >

                    <option value="">
                      Select SPH...
                    </option>

                  </select>

                </div>

                <div class="kjar-form-group">

                  <label
                    class="kjar-form-label"
                    for="kjar-right-cyl"
                  >
                    CYL (Cylinder)
                  </label>

                  <select
                    id="kjar-right-cyl"
                    class="kjar-form-input kjar-form-select"
                  >

                    <option value="">
                      Select CYL...
                    </option>

                  </select>

                </div>

                <div class="kjar-form-group">

                  <label
                    class="kjar-form-label"
                    for="kjar-right-axis"
                  >
                    AXIS
                  </label>

                  <select
                    id="kjar-right-axis"
                    class="kjar-form-input kjar-form-select"
                  >

                    <option value="">
                      Select AXIS...
                    </option>

                  </select>

                </div>

                <div
                  class="kjar-form-group"
                  id="kjar-right-add-group"
                  style="display:none;"
                >

                  <label
                    class="kjar-form-label"
                    for="kjar-right-add"
                  >
                    ADD Power
                  </label>

                  <select
                    id="kjar-right-add"
                    class="kjar-form-input kjar-form-select"
                  >

                    <option value="">
                      Select ADD...
                    </option>

                  </select>

                </div>

              </div>

              <!-- LEFT EYE -->

              <div class="kjar-prescription__eye">

                <span class="kjar-prescription__eye-label">
                  Left Eye (OS)
                </span>

                <div class="kjar-form-group">

                  <label
                    class="kjar-form-label"
                    for="kjar-left-sph"
                  >
                    SPH (Sphere)
                  </label>

                  <select
                    id="kjar-left-sph"
                    class="kjar-form-input kjar-form-select"
                  >

                    <option value="">
                      Select SPH...
                    </option>

                  </select>

                </div>

                <div class="kjar-form-group">

                  <label
                    class="kjar-form-label"
                    for="kjar-left-cyl"
                  >
                    CYL (Cylinder)
                  </label>

                  <select
                    id="kjar-left-cyl"
                    class="kjar-form-input kjar-form-select"
                  >

                    <option value="">
                      Select CYL...
                    </option>

                  </select>

                </div>

                <div class="kjar-form-group">

                  <label
                    class="kjar-form-label"
                    for="kjar-left-axis"
                  >
                    AXIS
                  </label>

                  <select
                    id="kjar-left-axis"
                    class="kjar-form-input kjar-form-select"
                  >

                    <option value="">
                      Select AXIS...
                    </option>

                  </select>

                </div>

                <div
                  class="kjar-form-group"
                  id="kjar-left-add-group"
                  style="display:none;"
                >

                  <label
                    class="kjar-form-label"
                    for="kjar-left-add"
                  >
                    ADD Power
                  </label>

                  <select
                    id="kjar-left-add"
                    class="kjar-form-input kjar-form-select"
                  >

                    <option value="">
                      Select ADD...
                    </option>

                  </select>

                </div>

              </div>

            </div>

            <div
              class="kjar-form-group kjar-prescription__pd"
              id="kjar-pd-group"
            >

              <label
                class="kjar-form-label"
                for="kjar-pd"
              >
                PD (Pupillary Distance)
              </label>

              <input
                type="number"
                step="0.5"
                id="kjar-pd"
                class="kjar-form-input"
                placeholder="e.g. 63"
              >

            </div>

          </div>

          <!-- UPLOAD PRESCRIPTION -->

          <div
            class="kjar-prescription__tab-content"
            data-prescription-mode="upload"
          >

            <div
              class="kjar-upload-zone"
              id="kjar-upload-zone"
            >

              <span class="kjar-upload-zone__icon">
                📄
              </span>

              <span class="kjar-upload-zone__text">
                Click to upload or drag & drop
              </span>

              <span class="kjar-upload-zone__hint">
                PDF, JPG or PNG (max 10MB)
              </span>

              <span
                class="kjar-upload-zone__file-name"
              ></span>

              <input
                type="file"
                class="kjar-upload-zone__input"
                accept=".pdf,.jpg,.jpeg,.png"
                hidden
              >

            </div>

          </div>

        </div>

        <!-- =====================================================
             STEP 4
             ===================================================== -->

        <div class="kjar-wizard__step">

          <h3 class="kjar-wizard__step-title">
            Review Your Selection
          </h3>

          <p class="kjar-wizard__step-subtitle">
            Confirm your lens selection and add to cart
          </p>

          <div class="kjar-wizard__summary">

            <div
              class="kjar-wizard__summary-items"
            ></div>

            <div
              class="kjar-wizard__summary-divider"
            ></div>

            <div
              class="kjar-wizard__summary-row kjar-wizard__summary-total"
            >

              <span>
                Total
              </span>

              <span
                class="kjar-wizard__summary-total-value"
              >
                ₹0
              </span>

            </div>

          </div>

          <div
            class="kjar-wizard__rx-details"
            id="kjar-rx-details"
            style="display:none;"
          ></div>

          <div
            class="kjar-wizard__disclaimer"
            id="kjar-disclaimer"
          >

            <label
              class="kjar-disclaimer__label"
            >

              <input
                type="checkbox"
                id="kjar-disclaimer-checkbox"
                class="kjar-disclaimer__checkbox"
              >

              <span
                class="kjar-disclaimer__text"
              >
                I confirm that the pupillary distance (PD)
                and prescription data provided by me is accurate
                and correct. I understand that
                <strong>KJAR</strong> will not be liable for any
                refund or exchange if the supplied data is incorrect.
              </span>

            </label>

          </div>

        </div>

        <!-- SUCCESS -->

        <div
          class="kjar-wizard__success"
          style="display:none;"
        >

          <div class="kjar-wizard__success-icon">
            ✅
          </div>

          <div class="kjar-wizard__success-title">
            Added to Cart!
          </div>

          <div class="kjar-wizard__success-text">
            Redirecting to cart...
          </div>

        </div>

      </div>

      <div class="kjar-wizard-panel__footer">

        <div class="kjar-wizard__cta">

          <button
            class="kjar-wizard__back-btn"
            style="display:none;"
          >
            ← Back
          </button>

          <button
            class="kjar-wizard__next-btn"
          >
            Continue
          </button>

          <button
            class="kjar-wizard__submit-btn"
            style="display:none;"
          >
            Add to Cart →
          </button>

        </div>

      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(panel);

    // Populate select dropdowns
    populateSelectOptions();

    // Close button
    document
      .getElementById('kjar-wizard-close')
      .addEventListener(
        'click',
        closeModal
      );

    overlay.addEventListener(
      'click',
      closeModal
    );

    // Wizard interactions
    bindPowerTypeOptions();
    bindPrescriptionTabs();
    bindUploadZone();
    bindNavigation();

    // Disclaimer checkbox
    var discCheckbox =
      document.getElementById(
        'kjar-disclaimer-checkbox'
      );

    if (discCheckbox) {

      discCheckbox.addEventListener(
        'change',
        function () {
          updateCTAs();
        }
      );

    }

    goToStep(1);
  }

  /**
   * Intercept Add to Cart button clicks
   */
  function bindAddToCartIntercept() {

    document.addEventListener(
      'click',
      function (e) {

        const target = e.target;

        const isAddToCart =
          target.closest(
            '.add-to-cart-button'
          ) ||
          target.closest(
            '.product-form__submit'
          ) ||
          target.closest(
            '[data-testid="standalone-add-to-cart"]'
          ) ||
          target.closest(
            '.sticky-add-to-cart__button'
          ) ||
          target.closest(
            '.buy-buttons-block button'
          ) ||
          target.closest(
            'button[name="add"]'
          );

        if (!isAddToCart) return;

        const lensData =
          document.querySelector(
            '.kjar-lens-wizard-data'
          );

        if (!lensData) return;

        /*
         * Find the correct product form.
         */
        const form =
          target.closest(
            'form[data-type="add-to-cart-form"]'
          ) ||
          document.querySelector(
            'form[data-type="add-to-cart-form"]'
          );

        /*
         * Always get the latest selected variant.
         */
        if (form) {

          const variantInput =
            form.querySelector(
              'input[name="id"]'
            );

          if (
            variantInput &&
            variantInput.value
          ) {

            state.variantId =
              variantInput.value;

          }

        }

        /*
         * =====================================================
         * SUNGLASSES
         * =====================================================
         *
         * Do NOT open the wizard.
         *
         * Directly add the selected variant to cart.
         */
        if (state.isSunglasses) {

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          handleSunglassesDirectAdd(
            form
          );

          return;
        }

        /*
         * =====================================================
         * EYEGLASSES / OTHER PRODUCTS
         * =====================================================
         *
         * Existing wizard behaviour.
         */
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        openModal();

      },
      true
    );

    /*
     * Intercept form submission
     */
    document.addEventListener(
      'submit',
      function (e) {

        const form = e.target;

        if (
          form.getAttribute(
            'data-type'
          ) !==
          'add-to-cart-form'
        ) {
          return;
        }

        const lensData =
          document.querySelector(
            '.kjar-lens-wizard-data'
          );

        if (!lensData) return;

        /*
         * Get latest selected variant.
         */
        const variantInput =
          form.querySelector(
            'input[name="id"]'
          );

        if (
          variantInput &&
          variantInput.value
        ) {

          state.variantId =
            variantInput.value;

        }

        /*
         * =====================================================
         * SUNGLASSES
         * =====================================================
         *
         * No wizard.
         * Direct add to cart.
         */
        if (state.isSunglasses) {

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          handleSunglassesDirectAdd(
            form
          );

          return;
        }

        /*
         * =====================================================
         * EYEGLASSES / OTHER PRODUCTS
         * =====================================================
         *
         * Existing wizard behaviour.
         */
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        openModal();

      },
      true
    );
  }

  /**
   * Direct add to cart for Sunglasses
   */
  async function handleSunglassesDirectAdd(form) {

    const variantInput =
      form?.querySelector(
        'input[name="id"]'
      );

    const variantId =
      variantInput?.value ||
      state.variantId;

    if (!variantId) {

      alert(
        'Unable to find the selected product variant.'
      );

      return;
    }

    state.variantId =
      variantId;

    /*
     * Find the actual Add to Cart button.
     */
    const submitButton =
      form?.querySelector(
        'button[type="submit"], button[name="add"]'
      ) ||
      document.querySelector(
        '.add-to-cart-button button, ' +
        '.product-form__submit, ' +
        '[data-testid="standalone-add-to-cart"]'
      );

    const originalText =
      submitButton?.innerHTML;

    if (submitButton) {

      submitButton.disabled =
        true;

      submitButton.innerHTML =
        '<span class="kjar-wizard__loading">' +
        '<span class="kjar-wizard__spinner"></span>' +
        ' Adding...</span>';

    }

    try {

      /*
       * KJAR bundle offers (Buy 2 / Buy 3): add every chosen
       * variant in a single request. Identical variants are merged
       * into one line item with an increased quantity. Bundle pricing
       * is applied downstream by an automatic discount / app.
       */
      const bundleQuantityField =
        form?.querySelector(
          'input[name="kjar_bundle_quantity"]'
        );

      const bundleVariantFields = form
        ? Array.from(
            form.querySelectorAll(
              'input[name="kjar_bundle_variant_id[]"]'
            )
          )
        : [];

      const bundleQuantity = Number(
        bundleQuantityField?.value || 1
      );

      const bundleVariantIds = bundleVariantFields
        .map((input) => input.value)
        .filter(Boolean);

      let res;

      if (bundleQuantity > 1 && bundleVariantIds.length > 0) {

        const merged = bundleVariantIds.reduce(
          (acc, id) => {
            acc[id] = (acc[id] || 0) + 1;
            return acc;
          },
          {}
        );

        const items = Object.keys(merged).map((id) => ({
          id: Number(id),
          quantity: merged[id],
        }));

        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: items }),
        });

      } else {

        const body = new URLSearchParams();

        body.append('id', variantId);

        body.append('quantity', '1');

        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
          },
          body: body.toString(),
        });

      }

      if (!res.ok) {

        const data =
          await res
            .json()
            .catch(
              () => ({})
            );

        throw new Error(
          data.description ||
          'Failed to add product to cart'
        );

      }

      /*
       * Notify cart components.
       */
      document.dispatchEvent(
        new CustomEvent(
          'cart:updated'
        )
      );

      /*
       * Go directly to cart.
       */
      window.location.href =
        '/cart';

    } catch (e) {

      console.error(
        'Sunglasses add to cart error:',
        e
      );

      alert(
        e.message ||
        'Something went wrong while adding the product to cart.'
      );

      if (submitButton) {

        submitButton.disabled =
          false;

        if (
          originalText !== undefined
        ) {

          submitButton.innerHTML =
            originalText;

        }

      }

    }
  }

  function openModal() {

    document
      .getElementById(
        'kjar-wizard-overlay'
      )
      .classList.add(
        'kjar-wizard-overlay--open'
      );

    document
      .getElementById(
        'kjar-wizard-panel'
      )
      .classList.add(
        'kjar-wizard-panel--open'
      );

    document.body.style.overflow =
      'hidden';

    goToStep(1);
  }

  function closeModal() {

    document
      .getElementById(
        'kjar-wizard-overlay'
      )
      .classList.remove(
        'kjar-wizard-overlay--open'
      );

    document
      .getElementById(
        'kjar-wizard-panel'
      )
      .classList.remove(
        'kjar-wizard-panel--open'
      );

    document.body.style.overflow =
      '';
  }

  function goToStep(step) {

    /*
     * Zero Power skips prescription step.
     *
     * Flow:
     * Step 1 → Step 2 → Step 4
     */
    if (
      state.powerType === 'zero_power'
    ) {

      if (step === 3) {
        step = 4;
      }

    }

    state.currentStep = step;

    const panel =
      document.getElementById(
        'kjar-wizard-panel'
      );

    panel
      .querySelectorAll(
        '.kjar-wizard__step'
      )
      .forEach(
        (el, i) => {

          el.classList.toggle(
            'kjar-wizard__step--active',
            i + 1 === step
          );

        }
      );

    updateProgressDots();
    updateCTAs();

    const err =
      document.getElementById(
        'kjar-wizard-error'
      );

    if (err) {

      err.classList.remove(
        'kjar-wizard__error--visible'
      );

    }
  }

  function updateProgressDots() {

    const panel =
      document.getElementById(
        'kjar-wizard-panel'
      );

    const skipRx =
      state.powerType === 'zero_power';

    panel
      .querySelectorAll(
        '.kjar-wizard__step-indicator'
      )
      .forEach(
        (indicator, i) => {

          // Step 3 is Rx
          if (
            skipRx &&
            i === 2
          ) {

            indicator.classList.add(
              'kjar-wizard__step-indicator--skipped'
            );

          } else {

            indicator.classList.remove(
              'kjar-wizard__step-indicator--skipped'
            );

          }

        }
      );

    panel
      .querySelectorAll(
        '.kjar-wizard__step-line'
      )
      .forEach(
        (line, i) => {

          // Line connecting Step 2 → Step 3
          if (
            skipRx &&
            i === 1
          ) {

            line.classList.add(
              'kjar-wizard__step-line--skip'
            );

          } else {

            line.classList.remove(
              'kjar-wizard__step-line--skip'
            );

          }

          line.classList.toggle(
            'kjar-wizard__step-line--done',
            i + 1 <
              state.currentStep
          );

        }
      );

    panel
      .querySelectorAll(
        '.kjar-wizard__step-dot'
      )
      .forEach(
        (dot, i) => {

          const stepNum =
            i + 1;

          dot.classList.remove(
            'kjar-wizard__step-dot--active',
            'kjar-wizard__step-dot--done'
          );

          if (
            stepNum <
            state.currentStep
          ) {

            dot.classList.add(
              'kjar-wizard__step-dot--done'
            );

            dot.textContent = '';

          } else if (
            stepNum ===
            state.currentStep
          ) {

            dot.classList.add(
              'kjar-wizard__step-dot--active'
            );

            dot.textContent =
              stepNum;

          } else {

            dot.textContent =
              stepNum;

          }

        }
      );

    panel
      .querySelectorAll(
        '.kjar-wizard__step-label'
      )
      .forEach(
        (label, i) => {

          label.classList.toggle(
            'kjar-wizard__step-label--active',
            i + 1 ===
              state.currentStep
          );

        }
      );
  }

  function updateCTAs() {

    const panel =
      document.getElementById(
        'kjar-wizard-panel'
      );

    const backBtn =
      panel.querySelector(
        '.kjar-wizard__back-btn'
      );

    const nextBtn =
      panel.querySelector(
        '.kjar-wizard__next-btn'
      );

    const submitBtn =
      panel.querySelector(
        '.kjar-wizard__submit-btn'
      );

    if (backBtn) {

      backBtn.style.display =
        state.currentStep === 1
          ? 'none'
          : '';

    }

    if (
      state.currentStep === 4
    ) {

      if (nextBtn) {
        nextBtn.style.display =
          'none';
      }

      if (submitBtn) {

        submitBtn.style.display =
          '';

        submitBtn.disabled =
          !isCurrentStepValid();

      }

    } else {

      if (nextBtn) {

        nextBtn.style.display =
          '';

        nextBtn.disabled =
          !isCurrentStepValid();

      }

      if (submitBtn) {
        submitBtn.style.display =
          'none';
      }

    }

    updateSummary();
  }

  function isCurrentStepValid() {

    switch (
      state.currentStep
    ) {

      case 1:

        return (
          state.powerType !== null
        );

      case 2:

        return (
          state.selectedLens !== null
        );

      case 3:

        return (
          state.powerType ===
            'frame_only' ||
          state.powerType ===
            'zero_power' ||
          (
            state.prescriptionMode ===
            'upload'
              ? state.uploadedFile !== null
              : true
          )
        );

      case 4:

        var skipRx =
          state.powerType ===
            'frame_only' ||
          state.powerType ===
            'zero_power';

        if (skipRx) {
          return true;
        }

        var cb =
          document.getElementById(
            'kjar-disclaimer-checkbox'
          );

        return cb
          ? cb.checked
          : false;

      default:

        return true;
    }
  }

  function bindPowerTypeOptions() {

    document
      .getElementById(
        'kjar-wizard-panel'
      )
      .querySelectorAll(
        '.kjar-wizard__option[data-power-type]'
      )
      .forEach(
        opt => {

          opt.addEventListener(
            'click',
            function () {

              document
                .getElementById(
                  'kjar-wizard-panel'
                )
                .querySelectorAll(
                  '.kjar-wizard__option'
                )
                .forEach(
                  o =>
                    o.classList.remove(
                      'kjar-wizard__option--selected'
                    )
                );

              this.classList.add(
                'kjar-wizard__option--selected'
              );

              state.powerType =
                this.dataset.powerType;

              updatePrescriptionVisibility();
              updateCTAs();

            }
          );

        }
      );
  }

  function bindPrescriptionTabs() {

    document
      .getElementById(
        'kjar-wizard-panel'
      )
      .querySelectorAll(
        '.kjar-prescription__tab'
      )
      .forEach(
        tab => {

          tab.addEventListener(
            'click',
            function () {

              document
                .getElementById(
                  'kjar-wizard-panel'
                )
                .querySelectorAll(
                  '.kjar-prescription__tab'
                )
                .forEach(
                  t =>
                    t.classList.remove(
                      'kjar-prescription__tab--active'
                    )
                );

              this.classList.add(
                'kjar-prescription__tab--active'
              );

              state.prescriptionMode =
                this.dataset.prescriptionMode;

              document
                .getElementById(
                  'kjar-wizard-panel'
                )
                .querySelectorAll(
                  '.kjar-prescription__tab-content'
                )
                .forEach(
                  c =>
                    c.classList.remove(
                      'kjar-prescription__tab-content--active'
                    )
                );

              document
                .getElementById(
                  'kjar-wizard-panel'
                )
                .querySelector(
                  '.kjar-prescription__tab-content[data-prescription-mode="' +
                    this.dataset.prescriptionMode +
                    '"]'
                )
                .classList.add(
                  'kjar-prescription__tab-content--active'
                );

              updateCTAs();

            }
          );

        }
      );
  }

  function bindUploadZone() {

    const zone =
      document.getElementById(
        'kjar-upload-zone'
      );

    const input =
      zone?.querySelector(
        '.kjar-upload-zone__input'
      );

    if (!zone || !input) {
      return;
    }

    zone.addEventListener(
      'click',
      () => input.click()
    );

    zone.addEventListener(
      'dragover',
      (e) => {

        e.preventDefault();

        zone.style.borderColor =
          '#1A1A1A';

      }
    );

    zone.addEventListener(
      'dragleave',
      () => {

        zone.style.borderColor =
          '';

      }
    );

    zone.addEventListener(
      'drop',
      (e) => {

        e.preventDefault();

        zone.style.borderColor =
          '';

        if (
          e.dataTransfer.files.length >
          0
        ) {

          handleFile(
            e.dataTransfer.files[0]
          );

        }

      }
    );

    input.addEventListener(
      'change',
      function () {

        if (
          this.files.length >
          0
        ) {

          handleFile(
            this.files[0]
          );

        }

      }
    );
  }

  function populateSelectOptions() {

    // SPH: -10.00 to +10.00
    // Step 0.25

    var sphSelects = [
      'kjar-right-sph',
      'kjar-left-sph'
    ];

    sphSelects.forEach(
      function (id) {

        var sel =
          document.getElementById(
            id
          );

        if (!sel) return;

        for (
          var v = -10;
          v <= 10;
          v += 0.25
        ) {

          var val =
            v.toFixed(2);

          var label =
            (v > 0 ? '+' : '') +
            val;

          sel.innerHTML +=
            '<option value="' +
            val +
            '">' +
            label +
            '</option>';

        }

      }
    );

    // CYL: -6.00 to +6.00
    // Step 0.25

    var cylSelects = [
      'kjar-right-cyl',
      'kjar-left-cyl'
    ];

    cylSelects.forEach(
      function (id) {

        var sel =
          document.getElementById(
            id
          );

        if (!sel) return;

        for (
          var v = -6;
          v <= 6;
          v += 0.25
        ) {

          var val =
            v.toFixed(2);

          var label =
            (v > 0 ? '+' : '') +
            val;

          sel.innerHTML +=
            '<option value="' +
            val +
            '">' +
            label +
            '</option>';

        }

      }
    );

    // AXIS: 0 to 180

    var axisSelects = [
      'kjar-right-axis',
      'kjar-left-axis'
    ];

    axisSelects.forEach(
      function (id) {

        var sel =
          document.getElementById(
            id
          );

        if (!sel) return;

        for (
          var v = 0;
          v <= 180;
          v += 1
        ) {

          sel.innerHTML +=
            '<option value="' +
            v +
            '">' +
            v +
            '°</option>';

        }

      }
    );

    // ADD: 0.75 to 3.50

    var addSelects = [
      'kjar-right-add',
      'kjar-left-add'
    ];

    addSelects.forEach(
      function (id) {

        var sel =
          document.getElementById(
            id
          );

        if (!sel) return;

        for (
          var v = 0.75;
          v <= 3.5;
          v += 0.25
        ) {

          var val =
            v.toFixed(2);

          sel.innerHTML +=
            '<option value="' +
            val +
            '">+' +
            val +
            '</option>';

        }

      }
    );
  }

  function updatePrescriptionVisibility() {

    var isBifocalOrProg =
      state.powerType ===
        'bifocal' ||
      state.powerType ===
        'progressive';

    var isProgressive =
      state.powerType ===
      'progressive';

    // ADD power fields

    var rightAdd =
      document.getElementById(
        'kjar-right-add-group'
      );

    var leftAdd =
      document.getElementById(
        'kjar-left-add-group'
      );

    if (rightAdd) {

      rightAdd.style.display =
        isBifocalOrProg
          ? ''
          : 'none';

    }

    if (leftAdd) {

      leftAdd.style.display =
        isBifocalOrProg
          ? ''
          : 'none';

    }

    // Progressive alert

    var alert =
      document.getElementById(
        'kjar-progressive-alert'
      );

    if (alert) {

      alert.style.display =
        isProgressive
          ? ''
          : 'none';

    }

    // PD label

    var pdGroup =
      document.getElementById(
        'kjar-pd-group'
      );

    var pdLabel =
      pdGroup
        ? pdGroup.querySelector(
            'label'
          )
        : null;

    if (pdLabel) {

      pdLabel.textContent =
        isProgressive
          ? 'PD (Pupillary Distance) *Required'
          : 'PD (Pupillary Distance) — Optional';

    }
  }

  function getHighPowerSurcharge() {

    var surcharge = 0;

    var rightSph =
      parseFloat(
        document.getElementById(
          'kjar-right-sph'
        )?.value || '0'
      );

    var leftSph =
      parseFloat(
        document.getElementById(
          'kjar-left-sph'
        )?.value || '0'
      );

    if (
      rightSph > 3 ||
      rightSph < -3
    ) {

      surcharge += 499;

    }

    if (
      leftSph > 3 ||
      leftSph < -3
    ) {

      surcharge += 499;

    }

    return surcharge;
  }

  function handleFile(file) {

    if (
      ![
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/jpg'
      ].includes(
        file.type
      )
    ) {

      showError(
        'Please upload a PDF, JPG, or PNG file.'
      );

      return;
    }

    state.uploadedFile =
      file;

    const zone =
      document.getElementById(
        'kjar-upload-zone'
      );

    zone.classList.add(
      'kjar-upload-zone--has-file'
    );

    zone.querySelector(
      '.kjar-upload-zone__text'
    ).innerHTML =
      '✓ File uploaded';

    zone.querySelector(
      '.kjar-upload-zone__file-name'
    ).textContent =
      file.name;

    updateCTAs();
  }

  function bindNavigation() {

    const panel =
      document.getElementById(
        'kjar-wizard-panel'
      );

    panel
      .querySelector(
        '.kjar-wizard__next-btn'
      )
      ?.addEventListener(
        'click',
        () => {

          if (
            !isCurrentStepValid()
          ) {
            return;
          }

          // Frame Only:
          // Skip all remaining steps

          if (
            state.currentStep === 1 &&
            state.powerType ===
              'frame_only'
          ) {

            handleFrameOnlySubmit();

            return;
          }

          goToStep(
            state.currentStep + 1
          );

        }
      );

    panel
      .querySelector(
        '.kjar-wizard__back-btn'
      )
      ?.addEventListener(
        'click',
        () => {

          if (
            state.currentStep <= 1
          ) {
            return;
          }

          // Zero Power:
          // Skip Rx in reverse

          if (
            state.powerType ===
              'zero_power' &&
            state.currentStep === 4
          ) {

            goToStep(2);

            return;
          }

          goToStep(
            state.currentStep - 1
          );

        }
      );

    panel
      .querySelector(
        '.kjar-wizard__submit-btn'
      )
      ?.addEventListener(
        'click',
        handleSubmit
      );
  }

  function updateRxDetails() {

    var rxContainer =
      document.getElementById(
        'kjar-rx-details'
      );

    if (!rxContainer) {
      return;
    }

    var skipRx =
      state.powerType ===
        'frame_only' ||
      state.powerType ===
        'zero_power';

    var showUpload =
      state.prescriptionMode ===
        'upload' &&
      state.uploadedFile;

    if (
      skipRx &&
      !showUpload
    ) {

      rxContainer.style.display =
        'none';

      return;
    }

    rxContainer.style.display =
      '';

    var getVal =
      function (id) {

        var el =
          document.getElementById(
            id
          );

        return el && el.value
          ? el.value
          : '—';

      };

    var formatSph =
      function (id) {

        var v =
          getVal(id);

        if (v === '—') {
          return v;
        }

        var n =
          parseFloat(v);

        return (
          (n > 0 ? '+' : '') +
          n.toFixed(2)
        );

      };

    var rSph =
      formatSph(
        'kjar-right-sph'
      );

    var rCyl =
      formatSph(
        'kjar-right-cyl'
      );

    var rAxis =
      getVal(
        'kjar-right-axis'
      );

    var rAdd =
      formatSph(
        'kjar-right-add'
      );

    var lSph =
      formatSph(
        'kjar-left-sph'
      );

    var lCyl =
      formatSph(
        'kjar-left-cyl'
      );

    var lAxis =
      getVal(
        'kjar-left-axis'
      );

    var lAdd =
      formatSph(
        'kjar-left-add'
      );

    var pdVal =
      getVal(
        'kjar-pd'
      );

    var html =
      '<h4 class="kjar-rx-details__title">Prescription Details</h4>';

    html +=
      '<table class="kjar-rx-table"><thead><tr><th></th><th>SPH</th><th>CYL</th><th>AXIS</th>';

    if (
      state.powerType ===
        'bifocal' ||
      state.powerType ===
        'progressive'
    ) {

      html +=
        '<th>ADD</th>';

    }

    html +=
      '</tr></thead><tbody>';

    html +=
      '<tr><td class="kjar-rx-table__eye">OD (Right)</td><td>' +
      rSph +
      '</td><td>' +
      rCyl +
      '</td><td>' +
      (
        rAxis !== '—'
          ? rAxis + '°'
          : '—'
      ) +
      '</td>';

    if (
      state.powerType ===
        'bifocal' ||
      state.powerType ===
        'progressive'
    ) {

      html +=
        '<td>' +
        rAdd +
        '</td>';

    }

    html +=
      '</tr>';

    html +=
      '<tr><td class="kjar-rx-table__eye">OS (Left)</td><td>' +
      lSph +
      '</td><td>' +
      lCyl +
      '</td><td>' +
      (
        lAxis !== '—'
          ? lAxis + '°'
          : '—'
      ) +
      '</td>';

    if (
      state.powerType ===
        'bifocal' ||
      state.powerType ===
        'progressive'
    ) {

      html +=
        '<td>' +
        lAdd +
        '</td>';

    }

    html +=
      '</tr></tbody></table>';

    html +=
      '<p class="kjar-rx-details__pd">PD: <strong>' +
      (
        pdVal !== '—'
          ? pdVal + 'mm'
          : '—'
      ) +
      '</strong></p>';

    rxContainer.innerHTML =
      html;

    // Show disclaimer for Rx types

    var disclaimer =
      document.getElementById(
        'kjar-disclaimer'
      );

    if (disclaimer) {

      disclaimer.style.display =
        '';

    }
  }

  function updateSummary() {

    const summary =
      document
        .getElementById(
          'kjar-wizard-panel'
        )
        ?.querySelector(
          '.kjar-wizard__summary'
        );

    if (!summary) {
      return;
    }

    summary.style.display =
      state.currentStep === 4
        ? ''
        : 'none';

    if (
      state.currentStep !== 4
    ) {
      return;
    }

    const lensPrice =
      state.selectedLens
        ? state.selectedLens.price
        : 0;

    var surcharge =
      getHighPowerSurcharge();

    var total =
      state.framePrice +
      lensPrice +
      surcharge;

    var itemsHtml = '';

    itemsHtml +=
      '<div class="kjar-wizard__summary-row">' +
      '<span class="kjar-wizard__summary-label">Frame</span>' +
      '<span class="kjar-wizard__summary-value">₹' +
      state.framePrice.toLocaleString(
        'en-IN'
      ) +
      '</span></div>';

    if (
      state.selectedLens
    ) {

      itemsHtml +=
        '<div class="kjar-wizard__summary-row">' +
        '<span class="kjar-wizard__summary-label">' +
        state.selectedLens.name +
        '</span>' +
        '<span class="kjar-wizard__summary-value">₹' +
        lensPrice.toLocaleString(
          'en-IN'
        ) +
        '</span></div>';

    }

    if (
      surcharge > 0
    ) {

      itemsHtml +=
        '<div class="kjar-wizard__summary-row">' +
        '<span class="kjar-wizard__summary-label">High Power Surcharge</span>' +
        '<span class="kjar-wizard__summary-value kjar-wizard__summary-value--surcharge">+₹' +
        surcharge.toLocaleString(
          'en-IN'
        ) +
        '</span></div>';

    }

    summary.querySelector(
      '.kjar-wizard__summary-items'
    ).innerHTML =
      itemsHtml;

    summary.querySelector(
      '.kjar-wizard__summary-total-value'
    ).textContent =
      '₹' +
      total.toLocaleString(
        'en-IN'
      );

    updateRxDetails();
  }

  function showError(msg) {

    const err =
      document.getElementById(
        'kjar-wizard-error'
      );

    if (err) {

      err.textContent =
        msg;

      err.classList.add(
        'kjar-wizard__error--visible'
      );

    }
  }

  /**
   * Direct add to cart for Frame Only
   */
  async function handleFrameOnlySubmit() {

    const panel =
      document.getElementById(
        'kjar-wizard-panel'
      );

    const nextBtn =
      panel.querySelector(
        '.kjar-wizard__next-btn'
      );

    const orig =
      nextBtn.innerHTML;

    nextBtn.innerHTML =
      '<span class="kjar-wizard__loading">' +
      '<span class="kjar-wizard__spinner"></span>' +
      ' Adding...</span>';

    nextBtn.disabled =
      true;

    try {

      const props = {
        _power_type:
          'frame_only',

        _lens_type:
          '',

        _prescription_mode:
          'skipped'
      };

      const frameBody =
        new URLSearchParams();

      frameBody.append(
        'id',
        state.variantId
      );

      frameBody.append(
        'quantity',
        '1'
      );

      Object.entries(
        props
      ).forEach(
        ([k, v]) =>
          frameBody.append(
            'properties[' +
              k +
              ']',
            v
          )
      );

      const fRes =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/x-www-form-urlencoded'
            },

            body:
              frameBody.toString()
          }
        );

      if (!fRes.ok) {

        const d =
          await fRes
            .json()
            .catch(
              () => ({})
            );

        throw new Error(
          d.description ||
          'Failed to add frame'
        );

      }

      // Success

      panel
        .querySelectorAll(
          '.kjar-wizard__step'
        )
        .forEach(
          el =>
            el.classList.remove(
              'kjar-wizard__step--active'
            )
        );

      panel.querySelector(
        '.kjar-wizard__progress'
      ).style.display =
        'none';

      panel.querySelector(
        '.kjar-wizard__cta'
      ).style.display =
        'none';

      panel.querySelector(
        '.kjar-wizard__success'
      ).style.display =
        'block';

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated'
        )
      );

      setTimeout(
        () => {
          window.location.href =
            '/cart';
        },
        800
      );

    } catch (e) {

      showError(
        e.message ||
        'Something went wrong'
      );

    } finally {

      nextBtn.innerHTML =
        orig;

      nextBtn.disabled =
        false;

    }
  }

  function buildPrescriptionSummary() {

    var getVal =
      function (id) {

        var el =
          document.getElementById(
            id
          );

        return el && el.value
          ? el.value
          : '';

      };

    var fmt =
      function (id) {

        var v =
          getVal(id);

        if (!v) {
          return '—';
        }

        return v;

      };

    var parts = [];

    parts.push(
      'OD: SPH ' +
      fmt('kjar-right-sph') +
      ' CYL ' +
      fmt('kjar-right-cyl') +
      ' AX ' +
      fmt('kjar-right-axis')
    );

    if (
      state.powerType ===
        'bifocal' ||
      state.powerType ===
        'progressive'
    ) {

      parts[
        parts.length - 1
      ] +=
        ' ADD ' +
        fmt(
          'kjar-right-add'
        );

    }

    parts.push(
      'OS: SPH ' +
      fmt('kjar-left-sph') +
      ' CYL ' +
      fmt('kjar-left-cyl') +
      ' AX ' +
      fmt('kjar-left-axis')
    );

    if (
      state.powerType ===
        'bifocal' ||
      state.powerType ===
        'progressive'
    ) {

      parts[
        parts.length - 1
      ] +=
        ' ADD ' +
        fmt(
          'kjar-left-add'
        );

    }

    var pd =
      getVal(
        'kjar-pd'
      );

    parts.push(
      'PD: ' +
      (
        pd ||
        '—'
      ) +
      'mm'
    );

    return parts.join(
      ' | '
    );
  }

  async function handleSubmit() {

    if (
      !isCurrentStepValid()
    ) {
      return;
    }

    const panel =
      document.getElementById(
        'kjar-wizard-panel'
      );

    const btn =
      panel.querySelector(
        '.kjar-wizard__submit-btn'
      );

    const orig =
      btn.innerHTML;

    btn.innerHTML =
      '<span class="kjar-wizard__loading">' +
      '<span class="kjar-wizard__spinner"></span>' +
      ' Adding...</span>';

    btn.disabled =
      true;

    var skipRx =
      state.powerType ===
        'frame_only' ||
      state.powerType ===
        'zero_power';

    try {

      // Build frame properties

      var props = {};

      props._power_type =
        state.powerType ||
        '';

      props._lens_type =
        state.selectedLens
          ? state.selectedLens.name
          : '';

      props._lens_price =
        state.selectedLens
          ? state.selectedLens.price
          : '';

      props._surcharge =
        getHighPowerSurcharge();

      props._prescription_mode =
        skipRx
          ? 'skipped'
          : state.prescriptionMode;

      // Manual prescription

      if (
        !skipRx &&
        state.prescriptionMode ===
          'manual'
      ) {

        props._right_sph =
          document.getElementById(
            'kjar-right-sph'
          )?.value ||
          '';

        props._right_cyl =
          document.getElementById(
            'kjar-right-cyl'
          )?.value ||
          '';

        props._right_axis =
          document.getElementById(
            'kjar-right-axis'
          )?.value ||
          '';

        props._right_add =
          document.getElementById(
            'kjar-right-add'
          )?.value ||
          '';

        props._left_sph =
          document.getElementById(
            'kjar-left-sph'
          )?.value ||
          '';

        props._left_cyl =
          document.getElementById(
            'kjar-left-cyl'
          )?.value ||
          '';

        props._left_axis =
          document.getElementById(
            'kjar-left-axis'
          )?.value ||
          '';

        props._left_add =
          document.getElementById(
            'kjar-left-add'
          )?.value ||
          '';

        props._pd =
          document.getElementById(
            'kjar-pd'
          )?.value ||
          '';

        props._prescription_summary =
          buildPrescriptionSummary();

      }

      // Add frame

      var frameBody =
        new URLSearchParams();

      frameBody.append(
        'id',
        state.variantId
      );

      frameBody.append(
        'quantity',
        '1'
      );

      Object.keys(
        props
      ).forEach(
        function (k) {

          if (
            props[k] !== ''
          ) {

            frameBody.append(
              'properties[' +
                k +
                ']',
              props[k]
            );

          }

        }
      );

      var fRes =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/x-www-form-urlencoded'
            },

            body:
              frameBody.toString()
          }
        );

      if (!fRes.ok) {

        var fd =
          await fRes
            .json()
            .catch(
              function () {
                return {};
              }
            );

        throw new Error(
          fd.description ||
          'Failed to add frame to cart'
        );

      }

      /*
       * Add lens as separate cart item
       *
       * This remains unchanged from your
       * existing prescription flow.
       */

      if (
        !skipRx &&
        state.selectedLens &&
        state.selectedLens.variantId
      ) {

        var lBody =
          new URLSearchParams();

        lBody.append(
          'id',
          state.selectedLens.variantId
        );

        lBody.append(
          'quantity',
          '1'
        );

        var lRes =
          await fetch(
            '/cart/add.js',
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/x-www-form-urlencoded'
              },

              body:
                lBody.toString()
            }
          );

        if (!lRes.ok) {

          var ld =
            await lRes
              .json()
              .catch(
                function () {
                  return {};
                }
              );

          throw new Error(
            ld.description ||
            'Failed to add lens to cart'
          );

        }

      }

      // Success

      panel
        .querySelectorAll(
          '.kjar-wizard__step'
        )
        .forEach(
          function (el) {

            el.classList.remove(
              'kjar-wizard__step--active'
            );

          }
        );

      panel.querySelector(
        '.kjar-wizard__progress'
      ).style.display =
        'none';

      panel.querySelector(
        '.kjar-wizard__cta'
      ).style.display =
        'none';

      panel.querySelector(
        '.kjar-wizard__success'
      ).style.display =
        'block';

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated'
        )
      );

      setTimeout(
        function () {

          window.location.href =
            '/cart';

        },
        800
      );

    } catch (e) {

      showError(
        e.message ||
        'Something went wrong'
      );

    } finally {

      btn.innerHTML =
        orig;

      btn.disabled =
        false;

    }
  }

  /**
   * Lens card clicks
   */
  document.addEventListener(
    'click',
    function (e) {

      const card =
        e.target.closest(
          '.kjar-lens-card'
        );

      if (
        !card ||
        !document
          .getElementById(
            'kjar-wizard-panel'
          )
          ?.classList.contains(
            'kjar-wizard-panel--open'
          )
      ) {
        return;
      }

      document
        .getElementById(
          'kjar-wizard-panel'
        )
        .querySelectorAll(
          '.kjar-lens-card'
        )
        .forEach(
          c =>
            c.classList.remove(
              'kjar-lens-card--selected'
            )
        );

      card.classList.add(
        'kjar-lens-card--selected'
      );

      state.selectedLens = {

        name:
          card.dataset.lensName,

        variantId:
          card.dataset.lensVariant,

        price:
          parseFloat(
            card.dataset.lensPrice ||
            '0'
          )

      };

      updateCTAs();
    }
  );

  /*
   * Initialize
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();